/**
 * Carrousels Swiper : [data-swiper="standard|diaporama|stories|logo"].
 * Navigation (.nav-prev / .nav-next), pagination (.swiper-pagination) et scrollbar
 * (.swiper-scrollbar) sont activées si le conteneur les contient.
 * Librairie swiper-bundle 7 (vendor.min.js, global `Swiper`, tous modules inclus).
 * Remplace les composants Vue SwiperStandard, SwiperDiaporama, SwiperStories, SwiperLogo.
 */
UNYC.register('swiper', () => {
    if (typeof window.Swiper !== 'function') return;

    const BASE = {
        speed: 1000,
        scrollbar: false,
        pagination: false,
        navigation: false,
        watchSlidesProgress: true,
    };

    const VARIANTS = {
        standard: { slidesPerView: 'auto' },
        diaporama: { slidesPerView: 'auto', centeredSlides: true },
        stories: { slidesPerView: 'auto', centeredSlides: true },
        logo: {
            slidesPerView: 'auto',
            loop: true,
            autoplay: { delay: 0, disableOnInteraction: false },
            speed: 5000,
            allowTouchMove: false,
            mousewheel: false,
        },
    };

    /**
     * Défilement des logos : les slides visibles aux extrémités reçoivent
     * `has-opacity first` / `has-opacity last` (fondu des bords, voir logo-partners/_logo.scss).
     */
    const watchVisibleSlides = (swiper) => {
        let previous = [];

        swiper.on('progress', () => {
            const visible = Array.from(swiper.visibleSlides || []);

            previous.forEach((slide) => {
                if (slide.classList.contains('has-opacity') &&
                    (slide.classList.contains('last') || slide.classList.contains('first'))) {
                    slide.classList.remove('has-opacity', 'last', 'first');
                }
            });

            if (visible.length) {
                visible[0].classList.add('has-opacity', 'first');

                if (visible.length > 1) {
                    visible[visible.length - 1].classList.add('has-opacity', 'last');
                }
            }

            previous = visible;
        });
    };

    UNYC.init('[data-swiper]', 'swiper', (el) => {
        const variant = el.dataset.swiper || 'standard';
        const options = Object.assign({}, BASE, VARIANTS[variant] || VARIANTS.standard);
        const navPrev = el.querySelector('.nav-prev');
        const navNext = el.querySelector('.nav-next');
        const pagination = el.querySelector('.swiper-pagination');
        const scrollbar = el.querySelector('.swiper-scrollbar');

        if (navPrev && navNext) {
            options.navigation = { prevEl: navPrev, nextEl: navNext };
        }

        if (pagination) {
            options.pagination = { el: pagination, clickable: true };
        }

        if (scrollbar) {
            options.scrollbar = { el: scrollbar, draggable: true };
        }

        const swiper = new window.Swiper(el, options);

        if (variant === 'logo') {
            watchVisibleSlides(swiper);
        }

        if (variant === 'diaporama') {
            swiper.slideTo(1);
        }

        el.unycSwiper = swiper;
    });
});
